function CalendarIcon() {
  return (
    <svg width='45' height='45' viewBox='0 0 45 45' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='45' height='45' rx='12' fill='#ECE9F2' />
      <g clipPath='url(#clip0_37061_87503)'>
        <path
          d='M28.4167 15.6654H27.5V14.7487C27.5 14.2445 27.0875 13.832 26.5833 13.832C26.0792 13.832 25.6667 14.2445 25.6667 14.7487V15.6654H18.3333V14.7487C18.3333 14.2445 17.9208 13.832 17.4167 13.832C16.9125 13.832 16.5 14.2445 16.5 14.7487V15.6654H15.5833C14.5658 15.6654 13.7592 16.4904 13.7592 17.4987L13.75 30.332C13.75 31.3404 14.5658 32.1654 15.5833 32.1654H28.4167C29.425 32.1654 30.25 31.3404 30.25 30.332V17.4987C30.25 16.4904 29.425 15.6654 28.4167 15.6654ZM28.4167 29.4154C28.4167 29.9195 28.0042 30.332 27.5 30.332H16.5C15.9958 30.332 15.5833 29.9195 15.5833 29.4154V20.2487H28.4167V29.4154ZM17.4167 22.082H19.25V23.9154H17.4167V22.082ZM21.0833 22.082H22.9167V23.9154H21.0833V22.082ZM24.75 22.082H26.5833V23.9154H24.75V22.082Z'
          fill='#402080'
        />
      </g>
      <defs>
        <clipPath id='clip0_37061_87503'>
          <rect width='22' height='22' fill='white' transform='translate(11 12)' />
        </clipPath>
      </defs>
    </svg>
  )
}
export default CalendarIcon
